var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10,
    stroke: "#DADADA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.96111 15L6.1398 11.6297C5.88332 11.3801 6.01156 10.8808 6.26805 10.6312C6.52453 10.3815 7.03749 10.5063 7.29397 10.756L9.08935 12.878L13.706 7.2609C13.9625 7.01126 14.4755 6.88643 14.732 7.13608C14.9884 7.38573 15.1167 7.88502 14.8602 8.13467L8.96111 15Z",
    fill: "#DADADA"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTAuNSIgY3k9IjEwLjUiIHI9IjEwIiBzdHJva2U9IiNEQURBREEiLz4KPHBhdGggZD0iTTguOTYxMTEgMTVMNi4xMzk4IDExLjYyOTdDNS44ODMzMiAxMS4zODAxIDYuMDExNTYgMTAuODgwOCA2LjI2ODA1IDEwLjYzMTJDNi41MjQ1MyAxMC4zODE1IDcuMDM3NDkgMTAuNTA2MyA3LjI5Mzk3IDEwLjc1Nkw5LjA4OTM1IDEyLjg3OEwxMy43MDYgNy4yNjA5QzEzLjk2MjUgNy4wMTEyNiAxNC40NzU1IDYuODg2NDMgMTQuNzMyIDcuMTM2MDhDMTQuOTg4NCA3LjM4NTczIDE1LjExNjcgNy44ODUwMiAxNC44NjAyIDguMTM0NjdMOC45NjExMSAxNVoiIGZpbGw9IiNEQURBREEiLz4KPC9zdmc+Cg==";
export { SvgIcCheck as ReactComponent };